import DashboardLayout from "./views/dashboardLayout";
import Auth from "../auth/middleware/Auth";
import AdminMiddleware from "../auth/middleware/AdminMiddleware";
import summaries from "./components/summaries";
// import dashboard from "./views/dashboard";
import notifications from "./components/notifications";
import accreditedInstitute from "./components/AccreditedUniversities";
import examCenters from "./components/examCenters";
import PublicReferenceMaterials from "./components/PublicReferenceMaterials";
import User from "../auth/middleware/User";

export default [
  {
    path: "/dashboard",
    component: DashboardLayout,
    children: [
      {
        path: "",
        redirect: "/dashboard/summary",
      },
      {
        path: "summary",
        name: "Summary",
        component: summaries,
        meta: { middleware: [Auth, User, AdminMiddleware] },
      },
      {
        path: "notifications",
        name: "Notifications",
        component: notifications,
        meta: { middleware: [Auth] },
      },
      {
        path: "AC",
        name: "accreditedInstitute",
        component: accreditedInstitute,
        meta: { middleware: [Auth] },
      },
      {
        path: "EC",
        name: "examCenters",
        component: examCenters,
        meta: { middleware: [Auth] },
      },
      {
        path: "PRM",
        name: "Public Reference Materials",
        component: PublicReferenceMaterials,
        meta: { middleware: [Auth] },
      },
    ],
  },
];
